import { BrowserRouter } from 'react-router'
import Theme from '@/components/template/Theme'
import Layout from '@/components/layouts'
import { AuthProvider } from '@/auth'
import Views from '@/views'
import appConfig from './configs/app.config'
import { PWAInstallPrompt } from '@/components/pwa/PWAInstallPrompt'
import { PlanLimitDialog } from '@/components/plan/PlanLimitDialog'
import { AccountClosedGate } from '@/components/account/AccountClosedGate'
import { TwoStepGate } from '@/components/account/TwoStepGate'

if (appConfig.enableMock) {
    import('./mock')
}

function App() {
    return (
        <Theme>
            <BrowserRouter>
                <AuthProvider>
                    <Layout>
                        <Views />
                    </Layout>
                    {/* PWA install banner + SW update toast. Sits at the
                        top of the tree so it can render fixed-position
                        UI regardless of the current route. Inert when
                        already installed or dismissed. */}
                    <PWAInstallPrompt />
                    {/* A plan's limit, from whichever screen started a document or an import. */}
                    <PlanLimitDialog />
                    {/* A closed account signing in again: Restore or Sign out. */}
                    <AccountClosedGate />
                    {/* Two-step sign-in on, and this session hasn't used the code yet. */}
                    <TwoStepGate />
                </AuthProvider>
            </BrowserRouter>
        </Theme>
    )
}

export default App
